<template>
  <ExternalQueryList
      headline="Secondary Menu Links"
      endpoint="/api/v2/secondary-menu-links"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/secondary-menu-links/priorities"
      :get-reorder-payload="data => ({secondary_menu_links: data})"
      @show="secondaryMenuLink => $router.push(getUrl(secondaryMenuLink))"
  >
    <template v-slot:default="{ row: secondaryMenuLink }">
      <td>
        <router-link :to="getUrl(secondaryMenuLink)">
          {{ secondaryMenuLink.attributes.text }}
        </router-link>
      </td>

      <td>
        {{ secondaryMenuLink.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/secondary-menu-links/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Text'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(secondaryMenuLink) {
      return '/portals/' + this.portal.id + '/content/secondary-menu-links/' + secondaryMenuLink.id + '/edit'
    }
  }
}
</script>
